import { render } from "./ProductForm.vue?vue&type=template&id=54d8b2d8"
import script from "./ProductForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"source/js/vue/components/sections/SAC/ProductForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54d8b2d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54d8b2d8', __exports__)) {
    api.reload('54d8b2d8', __exports__)
  }
  
  module.hot.accept("./ProductForm.vue?vue&type=template&id=54d8b2d8", () => {
    api.rerender('54d8b2d8', render)
  })

}


export default __exports__